import { ComponentChildren, FunctionalComponent, h } from 'preact';

interface ServiceCardItemProps {
	href: string;
	children: ComponentChildren;
}

export const ServiceCardItem: FunctionalComponent<ServiceCardItemProps> = (props) => {
	const { href } = props;
	return (
		<a href={href} className="SP-ServiceCard__link">
			{props.children}
		</a>
	);
};
